import React, { Component } from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';

import SelectOption from '../../components/Inputs/Select/Select';
import Toast from '../../components/Toast/Toast';

import CidadeService from '../../services/Cidade';
import { patternRegion } from '../../variables/Enums/Cidade';

import { isCoordenador, isApoioSecretarial, isCoordenadorOuApoioSecretarial } from '../../security/AuthorizedFunction';
import { getCoordenadorRegiao, getApoioSecretarialRegiao } from '../../security/keycloak';

export class RegiaoFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                regiao: this.regiaoDoPerfil(),
            },
            optionsRegiao: [],
            loadingOptionsRegiao: false,
        }
    }

    setToast = t => this.Toast = t;

    regiaoDoPerfil = () => isCoordenador() ? getCoordenadorRegiao() : isApoioSecretarial() ? getApoioSecretarialRegiao() : '';

    handleChange = e => {
        this.setState({
            filters: { ...this.state.filters, [e.target.name]: e.target.value }
        });
    }

    carregarRegioes = () => {
        this.setState({ loadingOptionsRegiao: true });

        CidadeService.filterRegioes([])
            .then(res => this.setState({ optionsRegiao: [...patternRegion(res.data.content)] }))
            .catch(() => this.Toast.setState({
                message: {
                    message: "Não Foi Possível Buscar as Regiões.",
                    type: 'error',
                    open: true
                }
            }))
            .finally(() => this.setState({ loadingOptionsRegiao: false }))
    }

    componentDidMount() {
        this.carregarRegioes();
    }

    render() {
        const somenteLeitura = isCoordenadorOuApoioSecretarial();

        return (
            <>
                <Toast parentRef={this.setToast} />

                <SelectOption
                    label="Região"
                    name='regiao'
                    value={this.state.filters.regiao}
                    onChange={this.handleChange}
                    options={this.state.optionsRegiao}
                    blankName="Todas"
                    disabled={somenteLeitura || this.state.loadingOptionsRegiao}
                    InputProps={{
                        startAdornment: this.state.loadingOptionsRegiao ? <InputAdornment position="start"><CircularProgress size={18} /></InputAdornment> : null,
                    }}
                />
            </>
        )
    }
}

export default RegiaoFilter;
